<template src="./index.html"></template>

<script>
export default {
	name: 'Authentication',
	props: {
		authenticationDialogShowFlag: {
			type: Boolean,
			default: false
		},

		//sms：验证码  qr:二维码
		smsOrQrCode: {
			type: String,
			default: "qr",
		},

		qrCode: {
			type: String,
			default: "",
		},
	},

	data() {
		return {
			smsCode: "",
			//qrCode:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZAAAAGQAQAAAACoxAthAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAJcEhZcwAAFxEAABcRAcom8z8AAADxSURBVHja7dZBcsQgDARA/v/pTaU2mBE2ld2zWhcbRHObEuP1dQ0EQRAE+YiMUr/r995TD0GQCFA5+NhDkPZkP5Lf2kMQpI6jfY0gyDliYyAIciaz1v849BCkO8nKsXTvIUh38lTj3EGQ9uT+VEuY4wlBepO5cQ2dUa9BEKSS+kybRxeJDoK0JnUg3VeLIQiSMVpBy4iVKxCkNdkrYe79/SFIa7KHq4Zuhu0KHYI0JxmlfMKtTvwhSHuSccqgrb1bxBAEOVwSgwlBkIeI5fEPU4kgLcisjFi97DqBIM1J1sJ76ErEEKQp+a4QBEEQ5N/6Aau+sfHYmazcAAAAAElFTkSuQmCC",
			qiybh: "",
			kpr: "",
			refreshDate: "",
		}
	},
	created() {
		let user = localStorage.getItem("useropj");
		let userInfo = JSON.parse(user);
		this.qiybh = userInfo.currCompany.code;
	},
	mounted() {
		//获取rpa配置
		this.$https.fetchGet('rpa/getDigitalRpaInfo', {
			qiybh: this.qiybh
		}).then(res => {
			console.log(res)
			if (res.status == 200) {
				this.kpr = res.data.data.loginAccount;
			}
		})
	},
	watch: {
		authenticationDialogShowFlag: function (indexVal, oldVal) {
			if(indexVal && this.smsOrQrCode=="sms"){
				this.getSmsCode();
			}
		}
	},
	methods: {

		getDate() {
			let date = new Date();
			return date.getFullYear() + '-' +
				('0' + (date.getMonth() + 1)).slice(-2) + '-' +
				('0' + date.getDate()).slice(-2) + ' ' +
				('0' + date.getHours()).slice(-2) + ':' +
				('0' + date.getMinutes()).slice(-2) + ':' +
				('0' + date.getSeconds()).slice(-2);

		},
		//初始化验证码
		getSmsCode() {
			
			const formData = new FormData()
			formData.append('refresh', false)
			this.$https.fetchPost('/rpa/authentication/getPhoneMessage/v2', formData).then(res => {
				if (res.data.code == '200') {
					this.refreshDate = res.data.data.msgTime;
					this.kpr = res.data.data.loginAccount;
				} else {
					this.$message.error(res.data.message);
				}

			})
		},
		//发送验证码
		sendSmsCode() {
			const formData = new FormData()
			formData.append('refresh', true)
			this.$https.fetchPost('/rpa/authentication/getPhoneMessage/v2', formData).then(res => {
				if (res.data.code == '200') {
					this.$message.success("验证码发送成功");
					this.refreshDate = res.data.data.msgTime;
					this.kpr = res.data.data.loginAccount;
				} else {
					this.$message.error(res.data.message);
				}

			})
		},

		//刷新二维码
		refreshQrCode() {
			const formData = new FormData()
			formData.append('refresh', true)
			this.$https.fetchPost('/rpa/authentication/getQrCode/v2', formData).then(res => {
				if (res.status == 200) {
					this.$message.success("刷新成功");
					this.refreshDate = res.data.data.qrCodeTime;
					this.qrCode = res.data.data.qrCode;
					this.kpr = res.data.data.loginAccount;
				} else {
					this.$message.error("二维码获取失败");
					this.refreshDate = "";
					this.qrCode = "";
					this.kpr = "";
				}
			})
		},
		//提交验证码
		submitSmsCode() {
			const formData = new FormData()
			formData.append('smsCode', this.smsCode)
			this.$https.fetchPost('/rpa/authentication/authCodeLogin/v2', formData).then(res => {
				if (res.data.code == '200') {
					this.$message.success("登录成功");
					this.closeDialog();
				} else {
					this.$message.error("验证码错误或失效！");
				}
			})
		},
		getRequestParam() {   //  获取请求后面的参数
			var requestParam = new Object();
			if (location.href.indexOf('?') != -1) {
				var url = location.href.substring(location.href.indexOf('?')); //获取url中"?"符后的字串
				var str = url.substr(1);
				let strs = str.split("&");
				for (var i = 0; i < strs.length; i++) {
					requestParam[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]); //获取中文参数转码<span style="font-family: Arial, Helvetica, sans-serif;">decodeURI</span>，（unescape只针对数字，中文乱码)
				}
			}
			return requestParam;
		},

		closeDialog() {
			this.smsCode = "";
			this.qrCode = "";
			this.authenticationDialogShowFlag = false;
			this.$emit("closeAuthenticationDialog");
		},
	},
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>